import { getCustomerEventAdminTableDataRetrieveLoader } from "gen/endpoints/customer-event-admin/customer-event-admin";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";

export const eventsRoutes: RouteObject = {
  id: "events",
  path: "events",
  children: [
    {
      id: "eventsIndex",
      index: true,
      loader: getCustomerEventAdminTableDataRetrieveLoader(),
      lazy: async () => {
        const { EventsPage } = await import("features/admin/events/EventsPage");
        return { Component: EventsPage };
      },
    },
    {
      id: "eventsRollback",
      path: "rollback",
      handle: {
        queryParams: ["fundFamilyId"],
      },
      lazy: async () => {
        const { EventsRollbackPage } = await import(
          "features/admin/events/EventsRollbackPage"
        );
        return { Component: EventsRollbackPage };
      },
    },
    {
      id: "event",
      path: ":customerEventId",
      lazy: async () => {
        const { EventPage } = await import("features/admin/events/EventPage");
        return { Component: EventPage };
      },
      children: [
        {
          id: "eventDetailsTab",
          index: true,
          path: "",
          lazy: async () => {
            const { EventDetailsTab } = await import(
              "features/admin/events/tabs/EventDetailsTab"
            );
            return { Component: EventDetailsTab };
          },
          handle: {
            title: i18n.t("common:details"),
          },
        },
        {
          id: "eventCreateDataTab",
          index: true,
          path: "create-data",
          lazy: async () => {
            const { EventCreateDataTab } = await import(
              "features/admin/events/tabs/EventCreateDataTab"
            );
            return { Component: EventCreateDataTab };
          },
          handle: {
            title: i18n.t("events:createData"),
          },
        },
      ],
    },
  ],
};
